export default {"src":"/_next/static/media/Group_42544.8670046e.svg","height":78,"width":80};